var CompanyOtherLoanDateMappingService = (function () {
    function CompanyOtherLoanDateMappingService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    CompanyOtherLoanDateMappingService.prototype.getAll = function (CompanyID) {
        return this.$http.post(this.WsUrl + "/GetAllCompanyOtherLoanDateMapping", {
            CompanyID: CompanyID
        });
    };
    CompanyOtherLoanDateMappingService.$inject = ["$http"];
    return CompanyOtherLoanDateMappingService;
}());
angular
    .module("London.Services")
    .service("CompanyOtherLoanDateMappingService", CompanyOtherLoanDateMappingService);
